import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { EasyClaimDocumentType } from 'src/easyclaim.api.client.typescript/src';
import { MemoPlaceholderScooterFrontLeft } from 'src/easyclaim.app.assets/artwork/placeholder/v2/PlaceholderScooterFrontLeft';
import { reportError } from 'src/easyclaim.app.libs/reportError';

import {
	DetailContainer,
	ExampleModalImage,
	ImageFileInputType,
	SelectImage,
	StyledInfoIcon,
} from '../../easyclaim.app.components/index';
import { Image } from '../../easyclaim.app.services/ImageSelectionService';
import { isAnyOfImagesLoading } from '../FourAdditionalPictures';
import { FourDiagonalPerspectivesProps } from '../FourDiagonalPerspectives';

export function ScooterFrontLeftControl(currentAppState: FourDiagonalPerspectivesProps) {
	return (
		<>
			<h3 className="four-diagonal-perspectives-vehicle-front-left-title">
				<FormattedMessage id="fourDiagonalPerspectives.vehicleFrontLeft.title" />
				<StyledInfoIcon
					className="four-diagonal-perspectives-example-icon four-diagonal-perspectives-vehicle-front-left-info-icon"
					onClick={() => {
						showExampleModal(currentAppState).catch(reportError);
					}}
				/>
			</h3>
			<DetailContainer className="four-diagonal-perspectives-image-container">
				<SelectImage
					componentId="vehicleFrontLeft"
					imageFileInputType={ImageFileInputType.CapturePicture}
					fileType={EasyClaimDocumentType.FrontLeftPicture}
					caseId={currentAppState.easyClaimCase?.caseId}
					easyClaimService={currentAppState.easyClaimService}
					currentImage={currentAppState.vehicleImageFrontLeft}
					title="vehicleImages.leftFrontOverview"
					placeholder={<MemoPlaceholderScooterFrontLeft className="photo-placeholder" />}
					marginBottom="1rem"
					onChange={(image) => {
						const newState = vehicleImageChanged(currentAppState, image);

						void currentAppState.setAppState(newState);
					}}
					onShowExample={() => {
						showExampleModal(currentAppState).catch(reportError);
					}}
					showUserFeedbackInfo={true}
					configuration={currentAppState.easyClaimCase!._configuration!}
					inputError={currentAppState.inputError}
					vehicleType={currentAppState.easyClaimCase?.vehicle?.vehicleTypeId}
				/>
			</DetailContainer>
		</>
	);
}

function vehicleImageChanged(currentAppState: AppState, image: Image | undefined): AppState {
	let images: Image[] = [];

	images = image ? images.concat([image]) : images;
	images = currentAppState.vehicleImageRearLeft
		? images.concat([currentAppState.vehicleImageRearLeft])
		: images;
	images = currentAppState.vehicleImageRearRight
		? images.concat([currentAppState.vehicleImageRearRight])
		: images;
	images = currentAppState.vehicleImageFrontRight
		? images.concat([currentAppState.vehicleImageFrontRight])
		: images;

	const isImageLoading = isAnyOfImagesLoading(images);

	const newState = Object.assign({}, currentAppState, {
		vehicleImageFrontLeft: image,
		isImageLoading: isImageLoading,
	});

	return newState;
}

function showExampleModal(currentAppState: AppState) {
	const images: ExampleModalImage[] = [
		{ src: `${process.env.PUBLIC_URL}/images/example-policycheck-motorbike-front-left.png` },
	];

	return currentAppState.showExampleModal(
		images,
		'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle',
		'fourPerspectivesExampleModal.button.close',
		'front-left-motorbike'
	);
}
